// ContactInfoSection.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiMail, FiPhone, FiMapPin, FiClock } from 'react-icons/fi';
import '../../../../assets/css/customer/subscreens/contact/ContactInfoSection.css';

const ContactInfoSection = () => {
  const contactInfo = [
    {
      id: 1,
      icon: <FiMail />,
      title: 'Email Us',
      info: 'crafthive25@gmail.com',
      
    },
    {
      id: 2,
      icon: <FiPhone />,
      title: 'Call Us',
      info: '+92325123456',
    },
    {
      id: 3,
      icon: <FiMapPin />,
      title: 'Visit Us',
      info: '123 Craft Street',
    },
    {
      id: 4,
      icon: <FiClock />,
      title: 'Working Hours',
      info: 'Mon - Fri: 9AM - 6PM',
    }
  ];

  return (
    <section className="contact-info-section">
      <Container>
        <Row className="contact-info-grid">
          {contactInfo.map((item) => (
            <Col lg={3} md={6} sm={6} key={item.id}>
              <div className="info-card">
                <div className="info-icon">{item.icon}</div>
                <h3 className="info-title">{item.title}</h3>
                <p className="info-text">{item.info}</p>
                <p className="info-subtext">{item.subInfo}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ContactInfoSection;